import { cn } from "../../utils/lib";

export function Search({ className, ...props }) {
  return (
    <svg
      //   xmlns="http://www.w3.org/2000/svg"
      //   width="14"
      //   height="14"
      viewBox="0 0 14 14"
      fill="none"
      className={cn("h-auto w-full block", className)}
      {...props}
    >
      <g clip-path="url(#clip0_1_376)">
        <path
          d="M6.1653 0C2.76585 0 0 2.76585 0 6.1653C0 9.56495 2.76585 12.3306 6.1653 12.3306C9.56495 12.3306 12.3306 9.56495 12.3306 6.1653C12.3306 2.76585 9.56495 0 6.1653 0ZM6.1653 11.1924C3.39339 11.1924 1.13821 8.93725 1.13821 6.16533C1.13821 3.39341 3.39339 1.13821 6.1653 1.13821C8.93722 1.13821 11.1924 3.39339 11.1924 6.1653C11.1924 8.93722 8.93722 11.1924 6.1653 11.1924Z"
          fill="#B0B5BF"
        />
        <path
          d="M13.833 13.0283L10.5701 9.76538C10.3478 9.54305 9.98771 9.54305 9.76538 9.76538C9.54305 9.98752 9.54305 10.348 9.76538 10.5701L13.0283 13.833C13.1394 13.9441 13.2849 13.9997 13.4306 13.9997C13.5761 13.9997 13.7218 13.9441 13.833 13.833C14.0553 13.6108 14.0553 13.2504 13.833 13.0283Z"
          fill="#B0B5BF"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_376">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
